import {
  Button,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import {
  RiCheckLine,
  RiDeleteBin6Line,
  RiDeleteBinLine,
  RiFileEditLine,
} from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import {
  openAddVideoFielsModel,
  openCreateVideos,
  openStudentReportModel,
} from "../../../modules/admin-modules/models/Actions";
import {
  acceptRequestWithoutVoucherRequest,
  deleteRequestRequest,
  editRequestRequest,
} from "../../../modules/admin-modules/video-requests/Actions";
import { RiQrScan2Line } from "react-icons/ri";
import { openUserQRCodeModel } from "../../../modules/admin-modules/models/Actions";
const VideosRequestTable = ({ setAdd, setSelectedData, searchTerm, setFilteredCount }) => {
  const videos = useSelector((state) => state.videoRequests.requests);
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.videoRequests.isLoading);
  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [selected, setSelected] = useState({
    id: "",
  });

  // Filter data based on search term (searches all data, not just current page)
  const filteredVideos = React.useMemo(() => {
    if (!videos) return [];
    if (!searchTerm) return videos;
    
    const searchLower = searchTerm.toLowerCase();
    return videos.filter((data) => {
      const videoTitle = data?.video?.title?.toLowerCase() || '';
      const studentName = data?.student?.name?.toLowerCase() || '';
      return videoTitle.includes(searchLower) || studentName.includes(searchLower);
    });
  }, [videos, searchTerm]);

  // Reset page number when search term changes
  useEffect(() => {
    setPageNumber(0);
  }, [searchTerm]);

  // Update filtered count for parent component
  useEffect(() => {
    if (setFilteredCount) {
      setFilteredCount(filteredVideos?.length || 0);
    }
  }, [filteredVideos, setFilteredCount]);

  // Paginate the filtered data
  const paginatedVideos = React.useMemo(() => {
    const startIndex = pageNumber * size;
    const endIndex = startIndex + size;
    return filteredVideos.slice(startIndex, endIndex);
  }, [filteredVideos, pageNumber, size]);

  const viewData = (data) => {
    setSelectedData(data);
    setSelected(data);
  };

  const Data = paginatedVideos?.map((data) => {
      return {
        ...data,
        id: data?.id,
        video_name: data?.video?.title,
        student_name: (
          <Text
            cursor="pointer"
            onClick={(e) => {
              e.stopPropagation(); // Prevent row selection
              if (data?.student) {
                setSelectedData(data.student);
                dispatch(openStudentReportModel());
              }
            }}
          >
            {data?.student?.name}
          </Text>
        ),
        chapter_id: data?.chapter?.id,
        payment_exception: data?.payment_exception ? data?.payment_exception : "لا يوجد",
        student_group: data?.student_group?.name,


        WithVoucher: (
          <IconButton
            variant="outline"
            border="0"
            color="green.600"
            aria-label="Call Sage"
            fontSize="20px"
            icon={<RiCheckLine />}
            onClick={async () => {
              let formData = new FormData();
              formData.append("_method", "PUT");
              formData.append("video_id", data?.video?.id);

              await dispatch(
                editRequestRequest({
                  formData: formData,
                  id: data?.id,
                })
              );
            }}
          />
        ),
        code: (
          <IconButton
            variant="outline"
            border="0"
            color="gray.600"
            aria-label="Call Sage"
            fontSize="20px"
            icon={<RiQrScan2Line />}
            onClick={() => dispatch(openUserQRCodeModel())}
          />
        ),
        WithoutVoucher: (
          <IconButton
            variant="outline"
            border="0"
            color="green.600"
            aria-label="Call Sage"
            fontSize="20px"
            icon={<RiCheckLine />}
            onClick={async () => {
              await dispatch(acceptRequestWithoutVoucherRequest(data?.id));
            }}
          />
        ),
        delete: (
          <IconButton
            variant="outline"
            border="0"
            color="gray.600"
            aria-label="Call Sage"
            fontSize="20px"
            icon={<RiDeleteBinLine color="red" />}
            onClick={() => {
              dispatch(deleteRequestRequest(data?.id));
            }}
          />
        ),
      };
    });
  
  const columns = [
    {
      Header: " عنوان الفيديو",
      accessor: "video_name",
    },
    {
      Header: "  اسم الطالب",
      accessor: "student_name",
    },
    {
      Header: "اسم المجموعة",
      accessor: "student_group",
    },
    {
      Header: "استثناء الدفع",
      accessor: "payment_exception",
    },
    {
      Header: "Qr Code",
      accessor: "code",
    },
    {
      Header: "قبول",
      accessor: "WithVoucher",
    },
    {
      Header: "حذف",
      accessor: "delete",
    },
  ];

  const actions = (
    <Menu>
      <MenuButton
        as={IconButton}
        aria-label="Options"
        icon={<RiFileEditLine />}
        size="sm"
        fontSize="20px"
        variant="outline"
        border="none"
      />
      <MenuList>
        <MenuItem
          onClick={() => {
            setAdd(false);
            dispatch(openCreateVideos());
          }}
        >
          تعديل
        </MenuItem>
        <MenuItem
          onClick={() =>
            // dispatch(deleteClubRequest(selected?.id))
            {
              //console.log('test')
            }
          }
        >
          حذف
        </MenuItem>
      </MenuList>
    </Menu>
  );
  return (
    <CTable
      selectedData={viewData}
      Columns={columns}
      Data={Data}
      path={"openModel"}
      Actions={actions}
      Title={``}
      subTitle=""
      btnTitle=""
      placeHolder=""
      noSearchBar={false}
      noFilter={true}
      footerBtnTitle
      filterList
      addButton
      addButtonTitle=""
      setPage={setPage}
      setPerPage={setPerPage}
      currentpage={pageNumber}
      setPageNumber={setPageNumber}
      noSecondSearchBar={true}
      isLoading={isLoading}
      perPage={size}
      totalPage={Math.ceil(filteredVideos?.length / size)}
      searchTerm={searchTerm}
    />
  );
};

export default VideosRequestTable;
